<template>
  <b-row>
    <b-col>
      <slot name="botoes-adicionais" />
      <b-btn
        v-if="opcoes.baixar && opcoes.baixar.visible !== false"
        v-b-tooltip.hover
        variant="none"
        title="O download será feito conforme os filtros atualmente selecionados"
        class="btn btn-outline-primary mr-1"
        size="sm"
        :disabled="!linhas || linhas.length == 0"
        @click="baixar(linhas)"
      >
        <font-awesome-icon
          style="margin-right:0.25rem"
          icon="fa-solid fa-file-export"
        />
        Exportar
      </b-btn>
      <b-btn
        v-if="opcoes.novo && opcoes.novo.visible !== false"
        v-b-tooltip.hover
        variant="none"
        class="btn btn-outline-primary mr-1"
        size="sm"
        :title="opcoes.NotificarLimite ? opcoes.LimiteMensagem : ''"
        @click="novo(linhas)"
      >
        <feather-icon
          style="margin-right:0.25rem"
          icon="PlusIcon"
        />Novo
      </b-btn>
      <b-btn
        v-if="opcoes.favoritar && opcoes.favoritar.visible !== false"
        variant="none"
        class="btn btn-outline-primary mr-1"
        size="sm"
        :disabled="!linhas || linhas.length == 0"
        @click="favoritar(linhas)"
      >
        <feather-icon
          icon="StarIcon"
          class="text-warning"
        />
        Favoritar
      </b-btn>
      <!-- v-if="mostrarRemover" -->
      <span
        v-if="opcoes.ativar && opcoes.ativar.visible !== false"
        v-b-tooltip.hover
        :title="(!linhas || linhas.length == 0) ? (opcoes.ativar.tooltipDisabled || 'Selecione um ou mais usuários para habilitar o botão') : ''"
        class="d-inline-block"
        tabindex="0"
      >
        <b-btn
          variant="none"
          size="sm"
          class="btn btn-outline-success mr-1"
          :disabled="!linhas || linhas.length == 0"
          @click="ativar(linhas)"
        >
          <feather-icon
            v-if="opcoes.ativar.icon === 'UserIcon'"
            style="margin-right:0.25rem"
            icon="UserIcon"
            size="16"
          />
          <font-awesome-icon
            v-else
            style="margin-right:0.25rem"
            icon="fa-solid fa-building"
          />{{ opcoes.ativar.label || 'Ativar' }}
        </b-btn>
      </span>
      <b-btn
        v-if="opcoes.remover && opcoes.remover.visible !== false"
        variant="none"
        size="sm"
        class="btn btn-outline-danger mr-1"
        :disabled="(!opcoes.inativar || !opcoes.inativar.evento) && (!linhas || linhas.length == 0)"
        @click="remover(linhas)"
      >
        <feather-icon
          style="margin-right:0.25rem"
          icon="TrashIcon"
        />{{ opcoes.inativar ? 'Inativar/Remover' : 'Remover' }}
      </b-btn>
      <b-btn
        v-if="opcoes.historico && opcoes.historico.visible !== false"
        v-b-tooltip.hover
        variant="none"
        title="Histórico de alterações"
        class="btn btn-outline-primary mr-1 rounded-circle"
        size="sm"
        style="width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
        @click="historico(linhas)"
      >
        <font-awesome-icon icon="fa-solid fa-list" />
      </b-btn>
      <b-btn
        v-if="opcoes.ajuda && opcoes.ajuda.visible !== false"
        v-b-tooltip.hover
        variant="none"
        title="Precisa de ajuda?"
        class="btn btn-outline-primary mr-1 rounded-circle"
        size="sm"
        style="width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
        @click="ajuda(linhas)"
      >
        <font-awesome-icon
          icon="fa-solid fa-question"
        />
      </b-btn>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import {
  defineComponent, reactive,
} from '@vue/composition-api'

export default defineComponent({
  props: {
    opcoes: {
      type: Object,
      required: true,
    },
    mostrarRemover: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      linhas: [],
    }
  },
  setup(props, context) {
    const opt = reactive(props.opcoes)
    const toast = useToast()

    const novo = linhasSelecionadas => {
      opt.novo.evento(linhasSelecionadas)
    }

    const baixar = linhasSelecionadas => {
      opt.baixar.evento(linhasSelecionadas)
    }

    const ajuda = () => {
      if (opt.ajuda && opt.ajuda.evento) {
        opt.ajuda.evento()
      }
    }

    const historico = linhasSelecionadas => {
      if (opt.historico && opt.historico.evento) {
        opt.historico.evento(linhasSelecionadas)
      }
    }

    const favoritar = linhasSelecionadas => {
      opt.favoritar.evento(linhasSelecionadas)
        .catch(err => {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível favoritar as informações',
              icon: 'fa-solid fa-circle-exclamation',
              variant: 'danger',
            },
          })
          throw err
        })
    }

    const remover = linhasSelecionadas => {
      const contemVarios = Array.isArray(linhasSelecionadas) ? linhasSelecionadas.length : 0

      if (opt.inativar && (!contemVarios || contemVarios.length === 0)) {
        opt.inativar.evento()
      } else if (!contemVarios || contemVarios.length === 0) {
        toast.error({
          component: ToastificationContent,
          props: {
            title: 'Selecione pelo menos um usuário',
            icon: 'fa-solid fa-circle-exclamation',
            variant: 'danger',
          },
        })
      } else {
        const title = opt.inativar ? 'Inativar/Remover?' : 'Remover?'
        const text = opt.inativar
          ? `Tem certeza que deseja inativar/remover ${contemVarios > 1 ? 'os registros' : 'o registro'}?`
          : `Tem certeza que deseja remover ${contemVarios > 1 ? 'os registros' : 'o registro'}?`

        Vue.swal({
          title,
          text,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          customClass: {
            confirmButton: 'btn btn-outline-primary mr-50',
            cancelButton: 'btn btn-outline-warning ',
          },
          buttonsStyling: false,
        })
          .then(result => {
            if (result.value) {
              opt.remover.evento(linhasSelecionadas)
                .then(() => {
                  context.emit('removido')
                  Vue.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Removido!',
                      icon: 'fa-solid fa-circle-check',
                      variant: 'success',
                    },
                  })
                })
                .catch(err => {
                  Vue.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Não foi possível remover as informações',
                      icon: 'fa-solid fa-circle-exclamation',
                      variant: 'danger',
                    },
                  })
                  throw err
                })
            }
          })
      }
    }

    const ativar = linhasSelecionadas => {
      let contemVarios = 0
      if (Array.isArray(linhasSelecionadas)) {
        contemVarios = linhasSelecionadas.length
      } else if (linhasSelecionadas) {
        contemVarios = 1
      }

      if (!contemVarios || contemVarios === 0) {
        toast.error({
          component: ToastificationContent,
          props: {
            title: 'Selecione pelo menos um usuário',
            icon: 'fa-solid fa-circle-exclamation',
            variant: 'danger',
          },
        })
      } else {
        const title = opt.ativar && opt.ativar.label ? `${opt.ativar.label}?` : 'Ativar?'
        const text = `Tem certeza que deseja ativar ${contemVarios > 1 ? 'os registros' : 'o registro'}?`

        Vue.swal({
          title,
          text,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          customClass: {
            confirmButton: 'btn btn-outline-primary mr-50',
            cancelButton: 'btn btn-outline-warning ',
          },
          buttonsStyling: false,
        })
          .then(result => {
            if (result.value) {
              opt.ativar.evento(linhasSelecionadas)
                .then(() => {
                  context.emit('removido')
                  let toastTitle = 'Ativado!'
                  if (opt.ativar && opt.ativar.label) {
                    toastTitle = opt.ativar.label === 'Reativar' ? 'Reativado!' : `${opt.ativar.label}!`
                  }
                  Vue.$toast({
                    component: ToastificationContent,
                    props: {
                      title: toastTitle,
                      icon: 'fa-solid fa-circle-check',
                      variant: 'success',
                    },
                  })
                })
                .catch(err => {
                  Vue.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Não foi possível ativar as informações',
                      icon: 'fa-solid fa-circle-exclamation',
                      variant: 'danger',
                    },
                  })
                  throw err
                })
            }
          })
      }
    }

    return {
      novo,
      baixar,
      remover,
      favoritar,
      ativar,
      ajuda,
      historico,
    }
  },
})
</script>
